<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">Carga Stock: {{ reference }} {{ originLabel ? `Origen: ${originLabel}` : '' }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-autocomplete
                                v-model="product"
                                :items="itemsProducts"
                                label="Codigo Producto"
                                auto-select-first
                                outlined
                                ref="cod"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field
                                v-model="quantity"
                                label="Cantidad"
                                outlined
                                required
                                type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-text-field 
                            v-model="reference" 
                            label="Referencia" 
                            outlined 
                            class="mb-3"
                            :disabled="disableRef"
                        ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete
                                v-model="provider"
                                :items="itemsProviders"
                                label="Origen"
                                outlined
                                auto-select-first
                                :disabled="disableRef"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="2" sm="2" md="2" class="pb-0">
                            <v-autocomplete
                                v-model="zone"
                                :items="itemsZones"
                                label="Zona"
                                outlined
                                auto-select-first
                                :disabled="disableRef"
                            ></v-autocomplete>
                        </v-col>

                        <v-col cols="1" sm="1" md="1">
                            <v-icon
                                color="success"
                                @click="onList"
                                v-text="'mdi-check-outline'"
                                :disabled="!isNewItemOk"
                            ></v-icon> - 
                            <v-icon v-if="disableRef"
                                color="warning"
                                @click="onEdit"
                                v-text="'mdi-circle-edit-outline'"
                            ></v-icon>
                        </v-col>
                    </v-row>
                    
                    <v-data-table
                        :headers="headers"
                        :items="productsAggregate"
                        
                        class="elevation-1 custom-font"
                    >
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small @click="deleteItem(item)">
                            mdi-delete
                        </v-icon>
                    </template>
                    </v-data-table>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancelStock">
                    Cancelar
                </v-btn>
                <v-btn :disabled="!isOk" color="blue darken-1" text @click="saveStock">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { getInventoryZonesItems } from '../../dataApi'
export default {
    name: 'stock',
    props: {
        products: {
            type: Array, default: () => []
        },
        providers: {
            type: Array, default: () => []
        }, 
    },
    data: () => ({
        selectedRef: null,
        product: 0,
        quantity: 0,
        provider: null,
        reference: '',
        itemsProducts: [],
        itemsProviders: [],
        productsAggregate:[],
        disableRef: false,
        originLabel: null,
        headers: [
            { text: 'Producto', value: 'description' },
            { text: 'Cantidad', value: 'quantity' },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        itemsZones: [],
        zone: null,
    }),

    methods: {
        async createdValuesItems(){
            this.itemsProducts = this.products.map(product => ({
               text: `${product.name} - ${product.description}`,
               value: product.id
            }))
            this.itemsProviders = this.providers.map(provider => ({
                text: provider.text,
                value: provider.value
            }))
            this.itemsZones = await getInventoryZonesItems();
        },

        async onList(){
            const quantity = parseInt(this.quantity)
            const product = this.itemsProducts.find(product => product.value === this.product)
            const exist = this.productsAggregate.findIndex(product => product.id === this.product)
            if(exist !== -1) {
                this.productsAggregate[exist].quantity += quantity;
            } else {
                this.productsAggregate.push({
                    id: this.product,
                    description: product.text,
                    quantity,
                });
            }
            this.quantity = 0;
            this.product = 0;
            this.disableRef = true;
            if(!this.originLabel) {
                const origin = this.itemsProviders.find(provider => provider.value === this.provider)
                if(origin) this.originLabel = origin.text
            }
            // await this.$nextTick();
            // const input = this.$refs.cod.$el.querySelector('input');
            // console.log(input)
            // if(input) input.focus;
        },
        deleteItem(item){
            const index = this.productsAggregate.findIndex(product => product.id === item.id)
            if (index !== -1) {
                this.productsAggregate.splice(index, 1);
            }
        },
        onEdit(){
            this.disableRef = false;
            this.originLabel = null;
        },
        cancelStock(){
            this.$emit("cancelStock", {})
        },
        saveStock(){
            const stock = {
                items: this.productsAggregate,
                reference: this.reference,
                origin: this.provider,
                zone: this.zone
            }
            console.log(stock)
            this.$emit("saveStock", stock)
        }
    },

    mounted() {
        this.createdValuesItems();
    },

    computed: {
        isNewItemOk(){
            return this.product !== 0 && parseInt(this.quantity) !== 0 && this.reference != '' && this.provider !== null;
        },
        isOk(){
            return this.productsAggregate.length > 0 && this.provider !== null && this.reference != '';
        }
    }
}
</script>